import { IFormInputProps } from '../../components/merchants/FormInput';
import { InputType } from '../../components/form/form-input-constants';
import { PARTNER_FORM_FIELDS, PARTNER_FORM_FIELDS_NAMES } from './new-partner-form';
export const PARTNER_NOTIFICATION_INPUTS = ({ t }): IFormInputProps[] => [
	{
		key: PARTNER_FORM_FIELDS.NOTIFICATION_SENDER_EMAIL,
		fieldName: PARTNER_FORM_FIELDS.NOTIFICATION_SENDER_EMAIL,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.NOTIFICATION_SENDER_EMAIL)}`,
		label: t(PARTNER_FORM_FIELDS_NAMES.NOTIFICATION_SENDER_EMAIL),
		tooltipText: t(PARTNER_FORM_FIELDS_NAMES.NOTIFICATION_SENDER_EMAIL_TOOLTIP),
		inputType: InputType.Text,
		isLabelIcon: true,
		autoComplete: 'off'
	},
	{
		key: PARTNER_FORM_FIELDS.REPLY_TO_EMAIL,
		fieldName: PARTNER_FORM_FIELDS.REPLY_TO_EMAIL,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.REPLY_TO_EMAIL)}`,
		label: t(PARTNER_FORM_FIELDS_NAMES.REPLY_TO_EMAIL),
		tooltipText: t(PARTNER_FORM_FIELDS_NAMES.REPLY_TO_EMAIL_TOOLTIP),
		inputType: InputType.Text,
		isLabelIcon: true,
		autoComplete: 'off'
	},
	{
		key: PARTNER_FORM_FIELDS.BCC_EMAIL,
		fieldName: PARTNER_FORM_FIELDS.BCC_EMAIL,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.BCC_EMAIL)}`,
		label: t(PARTNER_FORM_FIELDS_NAMES.BCC_EMAIL),
		tooltipText: t(PARTNER_FORM_FIELDS_NAMES.BCC_EMAIL_TOOLTIP),
		inputType: InputType.Text,
		isLabelIcon: true,
		autoComplete: 'off'
	},
	{
		key: PARTNER_FORM_FIELDS.NOTIFICATION_SENDER_PHONE,
		fieldName: PARTNER_FORM_FIELDS.NOTIFICATION_SENDER_PHONE,
		placeholder: `${t('NEW_APPLICATION.ENTER')} ${t(PARTNER_FORM_FIELDS_NAMES.NOTIFICATION_SENDER_PHONE)}`,
		label: t(PARTNER_FORM_FIELDS_NAMES.NOTIFICATION_SENDER_PHONE),
		tooltipText: t(PARTNER_FORM_FIELDS_NAMES.NOTIFICATION_SENDER_PHONE_TOOLTIP),
		isLabelIcon: true,
		inputType: InputType.Phone,
		defaultCountry: 'US',
		autoComplete: 'off'
	},
];
